<script lang="ts">
    import type {DatatypedFilterDefinition, GenericDatatypedFilterDefinition, RecordFilterableDatatype} from '../types';
    import {FilterableDatatype} from '../types';
    import {RecordValueFilter} from './datatypeValueFilter';

    export let filterDefinition: DatatypedFilterDefinition;
    export let linkType: 'origin' | 'target';

    if (filterDefinition.datatype.name !== FilterableDatatype.RECORD) throw new Error(`Invalid datatype for record ${linkType.toUpperCase()} filter (expected RECORD, got ${filterDefinition.datatype.name})`);

    const valueFilterDefinition = filterDefinition as GenericDatatypedFilterDefinition<RecordFilterableDatatype>;
</script>

<RecordValueFilter {valueFilterDefinition}/>